export const BASE_API_URL = '/api2/';
export const DEFAULT_TIMEOUT = 120_000;
export const REPORTS_TIMEOUT = 120_000;
